import { FetchResult, gql } from 'apollo-boost';
import { IVideoService } from '../../../models/video-service';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    query GetVideoServices ($platform: String) {
        video_services (platform: $platform) {
            uid,
            identifier,
            name,
            available,
        }
    }
`;

export async function getAllVideoServices(): Promise<IVideoService[]> {
    //hardcoding platform here
    const platform = 'extension';

    const result: FetchResult<{ video_services: IVideoService[] }> = await graphqlClient.query({
        query: QUERY,
        variables: { platform },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.video_services;
}
